/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\CategorySVG\Break.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Monday March 13th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday March 13th 2023 2:17:56 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */
import { SVGProps } from 'Content/SVG/SVGProps';

function Break(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} stroke={props.stroke} strokeWidth={props.strokeWidth} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M1008.65,578.72s-10.1-16.22-10.1-31.53c0,0-1.89-8.93-5.61-22.63h0c14.63-10.66-19.85-82.39-29.86-81.92h0c-9.05-18.35-19.8-35.26-32.2-46.82-5.91-9.99,26.65-11.6,20.5-19.08,0,0-307.89-44.13-496.76,.01-109.91,31.16-168.39,78.52-184,92.57l-5.31-.53c-79.3,15.99-165.87,28.55-192.05,106.63l.69,46.05c-4.17,.35-8.2,.73-11.05,1.07l5.3,51.98,10.11,2.69s21.64,5.73,32.75,5.73c0,0-.05-.92-.06-2.57,1.19,.06,2.38,.13,3.56,.19h24.01c3.33,10.8,9.67,21.02,19.13,29.54,29.39,26.48,77.27,26.69,106.94,.48,9.75-8.61,16.25-19.01,19.64-30.02H812.35c3.33,10.8,9.67,21.02,19.13,29.54,29.39,26.48,77.27,26.69,106.94,.48,9.75-8.61,16.25-19.01,19.64-30.02h19.67c-.18,2.83-.4,4.48-.4,4.48l23.63-5.26s5.13-29.19,9.97-57.08c-2.12-.56-5.47-1.07-8.93-1.5,2.88-17.09,5.52-33.49,6.64-42.49Z"/>
        </svg>
    );
}

export default Break;
